import React, { useState, useEffect } from "react";
import StepCircle from '../StepCircle';
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Stepper,
  Step,
  StepLabel,
  Grid,
} from "@mui/material";
import api from "../../api";

const steps = ["Datos Básicos", "Detalles Técnicos", "Otros Detalles"];

const initialVehiculo = {
  patente: "",
  tipo_vehiculo: "",
  marca: "",
  modelo: "",
  anio: "",
  chasis: "",
  motor: "",
  kilometraje: "",
  fecha_act_km: "",
  tipo_combustible: "nafta",
  estado: "OPERATIVO",
  fecha_ultimo_service: "",
  km_ultimo_service: "",
  km_proximo_service: "",
  alineacion_balanceo_km: "",
  tag: "",
  vencimiento_matafuego: "",
  medida_neumatico: "",
  indice_neumatico: "",
  medida_bateria: "",
  color: "",
  carpeta_en_drive: false,
  llave: "",
  direccion_sede: "",
  area_responsable: "",
  titular: "",
  observaciones_mecanicas: "",
  observaciones_carroceria: ""
};

const AgregarVehiculo = ({ handleClose, onUpdate }) => {
  const [step, setStep] = useState(0);
  const [vehiculo, setVehiculo] = useState(initialVehiculo);
  const [isStep1Valid, setIsStep1Valid] = useState(false);

  const numberFields = [
    "anio", "kilometraje", "km_ultimo_service", "km_proximo_service", "tag"
  ];
  const dateFields = [
    "fecha_act_km", "fecha_ultimo_service", "alineacion_balanceo_km", "vencimiento_matafuego"
  ];
  const requiredFields = [
    "patente", "tipo_vehiculo", "marca", "modelo", "anio"
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (numberFields.includes(name)) {
      setVehiculo({
        ...vehiculo,
        [name]: value === "" ? null : parseInt(value, 10)
      });
    } else if (dateFields.includes(name)) {
      setVehiculo({
        ...vehiculo,
        [name]: value === "" ? null : value
      });
    } else if (name === "carpeta_en_drive") {
      setVehiculo({ ...vehiculo, [name]: checked });
    } else {
      setVehiculo({ ...vehiculo, [name]: value });
    }
  };

  const sanitizeVehiculo = (vehiculo) => {
    const sanitized = { ...vehiculo };
    numberFields.forEach((field) => {
      if (sanitized[field] === "" || sanitized[field] === undefined) {
        if (requiredFields.includes(field)) {
          delete sanitized[field];
        } else {
          sanitized[field] = null;
        }
      }
    });
    dateFields.forEach((field) => {
      if (sanitized[field] === "" || sanitized[field] === undefined) {
        if (requiredFields.includes(field)) {
          delete sanitized[field];
        } else {
          sanitized[field] = null;
        }
      }
    });
    return sanitized;
  };

  const handleNext = () => setStep((prev) => prev + 1);
  const handleBack = () => setStep((prev) => prev - 1);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = sanitizeVehiculo(vehiculo);
    api.post("vehiculos/", data)
      .then((res) => {
        alert("Vehículo agregado correctamente");
        if (onUpdate) {
          onUpdate(res.data); // send the new data to parent
        }
        handleClose();
      })
      .catch(() => alert("Hubo un error al agregar el vehículo."));
  };

  const fieldLabels = {
    anio: "Año",
    chasis: "Chasis",
    motor: "Motor",
    kilometraje: "Kilometraje",
    fecha_act_km: "Fecha Act Km",
    fecha_ultimo_service: "Fecha Último Service",
    km_ultimo_service: "Km Último Service",
    km_proximo_service: "Km Próximo Service",
    alineacion_balanceo_km: "Alineación Balanceo Km",
  };

  const toTitleCase = (str) =>
    str.replace(/_/g, ' ').replace(/\w\S*/g, (txt) =>
      txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );

  useEffect(() => {
    const { patente, tipo_vehiculo, marca, modelo } = vehiculo;
    setIsStep1Valid(!!(patente && tipo_vehiculo && marca && modelo));
  }, [vehiculo]);

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "700px", margin: "0 auto" }}>
      <Typography variant="h6" style={{ color: '#152d51', fontWeight: 'bold' }}>Agregar Vehículo</Typography>
      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={StepCircle}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {step === 0 && (
        <Grid container spacing={2} mt={2}>
          {["patente", "tipo_vehiculo", "marca", "modelo"].map((field, idx) => (
            <Grid item xs={6} key={idx}>
              <TextField
                label={field.charAt(0).toUpperCase() + field.slice(1).replace('_', ' ')}
                name={field}
                value={vehiculo[field]}
                onChange={handleChange}
                fullWidth
                required
              />
            </Grid>
          ))}
          <Grid item xs={12}>
            <Button fullWidth variant="contained" sx={{ background: '#152d51' }} onClick={handleNext} disabled={!isStep1Valid}>
              Siguiente
            </Button>
          </Grid>
        </Grid>
      )}

      {step === 1 && (
        <Grid container spacing={2} mt={2}>
          {[
            ["anio", "number"], ["chasis"], ["motor"], ["kilometraje", "number"],
            ["fecha_act_km", "date"], ["fecha_ultimo_service", "date"], ["km_ultimo_service", "number"],
            ["km_proximo_service", "number"], ["alineacion_balanceo_km", "date"],
          ].map(([field, type = "text"], idx) => (
            <Grid item xs={6} key={idx}>
              <TextField
                label={fieldLabels[field] || field.replace(/_/g, ' ').toUpperCase()}
                name={field}
                type={type}
                value={vehiculo[field] || ""}
                onChange={handleChange}
                fullWidth
                {...(type === "date" && { InputLabelProps: { shrink: true } })}
              />
            </Grid>
          ))}
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Combustible</InputLabel>
              <Select name="tipo_combustible" value={vehiculo.tipo_combustible} onChange={handleChange}>
                {["nafta", "diesel", "electrico", "hibrido"].map((option) => (
                  <MenuItem value={option} key={option}>{option.charAt(0).toUpperCase() + option.slice(1)}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Estado</InputLabel>
              <Select name="estado" value={vehiculo.estado} onChange={handleChange}>
                {["NO OPERATIVO", "CEDIDO", "NO OPERATIVO"].map((option) => (
                  <MenuItem value={option} key={option}>{option.replace('_', ' ')}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl>
              <label style={{ display: "block", marginBottom: 6, fontWeight: 500 }}>
                Carpeta en Drive
              </label>
              <input
                type="checkbox"
                name="carpeta_en_drive"
                checked={vehiculo.carpeta_en_drive}
                onChange={handleChange}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <Button fullWidth variant="outlined" onClick={handleBack}>Atrás</Button>
          </Grid>
          <Grid item xs={6}>
            <Button fullWidth variant="contained" sx={{ background: '#152d51' }} onClick={handleNext}>
              Siguiente
            </Button>
          </Grid>
        </Grid>
      )}

      {step === 2 && (
        <Grid container spacing={2} mt={2}>
          {[
            "tag", "vencimiento_matafuego", "medida_neumatico", "indice_neumatico",
            "medida_bateria", "color", "llave", "direccion_sede", "area_responsable", "titular"
          ].map((field, idx) => (
            <Grid item xs={6} key={idx}>

              {["vencimiento_matafuego"].includes(field) ? (
                <TextField
                  label={toTitleCase(field)}
                  name={field}
                  type="date"
                  value={vehiculo[field] || ""}
                  onChange={handleChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              ) : (
                <TextField
                  label={toTitleCase(field)}
                  type={field === "tag" ? "number" : "text"}
                  name={field}
                  value={vehiculo[field] || ""}
                  onChange={handleChange}
                  fullWidth
                />
              )}
            </Grid>
          ))}
          {["observaciones_mecanicas", "observaciones_carroceria"].map((field, idx) => (
            <Grid item xs={12} key={idx}>
              <TextField
                label={toTitleCase(field)}
                name={field}
                value={vehiculo[field] || ""}
                onChange={handleChange}
                fullWidth
                multiline
                rows={3}
              />
            </Grid>
          ))}
          <Grid item xs={6}>
            <Button fullWidth variant="outlined" onClick={handleBack}>Atrás</Button>
          </Grid>
          <Grid item xs={6}>
            <Button fullWidth type="submit" variant="contained" sx={{ background: '#152d51' }}>
              Agregar Vehículo
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default AgregarVehiculo;
